import { MaxHeightWrapper, StepWrapper } from '../../../styles';
import { TranslatedTitle } from '../components';

import { ChooseCoursesChecker } from '@/components/Onboarding/ChooseCoursesChecker';
import { Box } from '@/components/Utils';

export const ChooseCourses = () => {
  return (
    <StepWrapper>
      <Box display="flex" flexDirection="column" gap={12}>
        <TranslatedTitle i18nKey="CHOOSE_COURSES" />
      </Box>

      <MaxHeightWrapper>
        <ChooseCoursesChecker />
      </MaxHeightWrapper>
    </StepWrapper>
  );
};
